"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingApi = void 0;
var runtime = require("../runtime");
var index_1 = require("../models/index");
/**
 *
 */
var BookingApi = /** @class */ (function (_super) {
    __extends(BookingApi, _super);
    function BookingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * AlwaysCrashes is a dangerous route, cause it has a dangerous name. All it really does is emit a sentry alert saying  this endpoint was called.
     */
    BookingApi.prototype.bookingAlwaysCrashesRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/alwayscrash",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * AlwaysCrashes is a dangerous route, cause it has a dangerous name. All it really does is emit a sentry alert saying  this endpoint was called.
     */
    BookingApi.prototype.bookingAlwaysCrashes = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingAlwaysCrashesRaw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * AlwaysFail always returns a failure. Use this to test against failure scenarios. We need to convert the  string input to an enum value so the available options are visible to you.
     */
    BookingApi.prototype.bookingAlwaysFailRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['requestedFailure'] == null) {
                            throw new runtime.RequiredError('requestedFailure', 'Required parameter "requestedFailure" was null or undefined when calling bookingAlwaysFail().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/alwaysfail",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.RequestedFailureToJSON)(requestParameters['requestedFailure']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * AlwaysFail always returns a failure. Use this to test against failure scenarios. We need to convert the  string input to an enum value so the available options are visible to you.
     */
    BookingApi.prototype.bookingAlwaysFail = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingAlwaysFailRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Conversion analysis: convert UF to EDI, and describe all the alterations that were made
     */
    BookingApi.prototype.bookingAnalyzeConversionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['analyzeConversionRequest'] == null) {
                            throw new runtime.RequiredError('analyzeConversionRequest', 'Required parameter "analyzeConversionRequest" was null or undefined when calling bookingAnalyzeConversion().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/analyze",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.AnalyzeConversionRequestToJSON)(requestParameters['analyzeConversionRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AnalyzeConversionResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Conversion analysis: convert UF to EDI, and describe all the alterations that were made
     */
    BookingApi.prototype.bookingAnalyzeConversion = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingAnalyzeConversionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingAnalyzeRequestIDRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['analyzeRequestIDRequest'] == null) {
                            throw new runtime.RequiredError('analyzeRequestIDRequest', 'Required parameter "analyzeRequestIDRequest" was null or undefined when calling bookingAnalyzeRequestID().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/admin/analyze_request_id",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.AnalyzeRequestIDRequestToJSON)(requestParameters['analyzeRequestIDRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.AnalyzeRequestIDResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingAnalyzeRequestID = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingAnalyzeRequestIDRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * ClearRuntimeConfigCache clears the runtime config cache. This is so we re-hydrate the FTP configs and secrets.
     */
    BookingApi.prototype.bookingClearRuntimeConfigCacheRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/admin/clear_runtime_config_cache",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * ClearRuntimeConfigCache clears the runtime config cache. This is so we re-hydrate the FTP configs and secrets.
     */
    BookingApi.prototype.bookingClearRuntimeConfigCache = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingClearRuntimeConfigCacheRaw(initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Convert an EDI document to a JSON document. This uses TEDI.
     */
    BookingApi.prototype.bookingConvertEDIToJsonRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['conversionRequest'] == null) {
                            throw new runtime.RequiredError('conversionRequest', 'Required parameter "conversionRequest" was null or undefined when calling bookingConvertEDIToJson().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/tedi/convert",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.ConversionRequestToJSON)(requestParameters['conversionRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ConversionResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Convert an EDI document to a JSON document. This uses TEDI.
     */
    BookingApi.prototype.bookingConvertEDIToJson = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingConvertEDIToJsonRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Convert an Uberfreight (at the time of writing, specifically a BASF sourced document) to an EDI document. This uses TEDI.
     */
    BookingApi.prototype.bookingConvertUFToEdiRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['conversionRequest'] == null) {
                            throw new runtime.RequiredError('conversionRequest', 'Required parameter "conversionRequest" was null or undefined when calling bookingConvertUFToEdi().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/tedi/convert_uf_to_edi",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.ConversionRequestToJSON)(requestParameters['conversionRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ConversionResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Convert an Uberfreight (at the time of writing, specifically a BASF sourced document) to an EDI document. This uses TEDI.
     */
    BookingApi.prototype.bookingConvertUFToEdi = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingConvertUFToEdiRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a tender, supplying all information at the time of creation. This is the most flexible way to create a tender,  however it\'s also the most complicated for the client to use.  deprecated
     */
    BookingApi.prototype.bookingCreateTenderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['createTenderRequest'] == null) {
                            throw new runtime.RequiredError('createTenderRequest', 'Required parameter "createTenderRequest" was null or undefined when calling bookingCreateTender().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/create",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.CreateTenderRequestToJSON)(requestParameters['createTenderRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateTenderResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a tender, supplying all information at the time of creation. This is the most flexible way to create a tender,  however it\'s also the most complicated for the client to use.  deprecated
     */
    BookingApi.prototype.bookingCreateTender = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingCreateTenderRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a tender, supplying all information at the time of creation. This is the most flexible way to create a tender,  however it\'s also the most complicated for the client to use.
     */
    BookingApi.prototype.bookingCreateTenderCustomerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingCreateTenderCustomer().');
                        }
                        if (requestParameters['createTenderRequest'] == null) {
                            throw new runtime.RequiredError('createTenderRequest', 'Required parameter "createTenderRequest" was null or undefined when calling bookingCreateTenderCustomer().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/create".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.CreateTenderRequestToJSON)(requestParameters['createTenderRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateTenderResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a tender, supplying all information at the time of creation. This is the most flexible way to create a tender,  however it\'s also the most complicated for the client to use.
     */
    BookingApi.prototype.bookingCreateTenderCustomer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingCreateTenderCustomerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a tender using a pre-defined pattern. Along with the pattern, the client must provide the inputs for the pattern
     */
    BookingApi.prototype.bookingCreateTenderFromPatternRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingCreateTenderFromPattern().');
                        }
                        if (requestParameters['createTenderPatternRequest'] == null) {
                            throw new runtime.RequiredError('createTenderPatternRequest', 'Required parameter "createTenderPatternRequest" was null or undefined when calling bookingCreateTenderFromPattern().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/create_from_pattern".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.CreateTenderPatternRequestToJSON)(requestParameters['createTenderPatternRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateTenderResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a tender using a pre-defined pattern. Along with the pattern, the client must provide the inputs for the pattern
     */
    BookingApi.prototype.bookingCreateTenderFromPattern = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingCreateTenderFromPatternRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingCreateTenderFromPatternUsingEstablishedDataRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingCreateTenderFromPatternUsingEstablishedData().');
                        }
                        if (requestParameters['createTenderPatternEstablishedDataRequest'] == null) {
                            throw new runtime.RequiredError('createTenderPatternEstablishedDataRequest', 'Required parameter "createTenderPatternEstablishedDataRequest" was null or undefined when calling bookingCreateTenderFromPatternUsingEstablishedData().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/create_from_pattern_using_established_data".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.CreateTenderPatternEstablishedDataRequestToJSON)(requestParameters['createTenderPatternEstablishedDataRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateTenderResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingCreateTenderFromPatternUsingEstablishedData = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingCreateTenderFromPatternUsingEstablishedDataRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * deprecated
     */
    BookingApi.prototype.bookingCreateWaybillRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['createWaybillRequest'] == null) {
                            throw new runtime.RequiredError('createWaybillRequest', 'Required parameter "createWaybillRequest" was null or undefined when calling bookingCreateWaybill().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/waybills",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.CreateWaybillRequestToJSON)(requestParameters['createWaybillRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateWaybillResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * deprecated
     */
    BookingApi.prototype.bookingCreateWaybill = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingCreateWaybillRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingCreateWaybillMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['createWaybillMappingRequest'] == null) {
                            throw new runtime.RequiredError('createWaybillMappingRequest', 'Required parameter "createWaybillMappingRequest" was null or undefined when calling bookingCreateWaybillMapping().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/mappings/create",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.CreateWaybillMappingRequestToJSON)(requestParameters['createWaybillMappingRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.CreateWaybillMappingResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingCreateWaybillMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingCreateWaybillMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingDeletePatternRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingDeletePattern().');
                        }
                        if (requestParameters['patternId'] == null) {
                            throw new runtime.RequiredError('patternId', 'Required parameter "patternId" was null or undefined when calling bookingDeletePattern().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/patterns/{patternId}".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))).replace("{".concat("patternId", "}"), encodeURIComponent(String(requestParameters['patternId']))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingDeletePattern = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingDeletePatternRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * DownloadArchiveFiles is a legacy route that was used to collate all files related to a booking. This is a developer-only route.  Most likely going to be deprecated soon.
     */
    BookingApi.prototype.bookingDownloadArchiveFilesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['downloadArchiveFilesRequest'] == null) {
                            throw new runtime.RequiredError('downloadArchiveFilesRequest', 'Required parameter "downloadArchiveFilesRequest" was null or undefined when calling bookingDownloadArchiveFiles().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/admin/download_archive_files",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.DownloadArchiveFilesRequestToJSON)(requestParameters['downloadArchiveFilesRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.DownloadArchiveFilesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * DownloadArchiveFiles is a legacy route that was used to collate all files related to a booking. This is a developer-only route.  Most likely going to be deprecated soon.
     */
    BookingApi.prototype.bookingDownloadArchiveFiles = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingDownloadArchiveFilesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * FindWaybills searches waybills by a given column and value, like request_id, bol_number, etc
     */
    BookingApi.prototype.bookingFindWaybillsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['findWaybillsRequest'] == null) {
                            throw new runtime.RequiredError('findWaybillsRequest', 'Required parameter "findWaybillsRequest" was null or undefined when calling bookingFindWaybills().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/find",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.FindWaybillsRequestToJSON)(requestParameters['findWaybillsRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.FindWaybillsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * FindWaybills searches waybills by a given column and value, like request_id, bol_number, etc
     */
    BookingApi.prototype.bookingFindWaybills = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingFindWaybillsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * FindWaybills searches waybills by a given column and value, like request_id, bol_number, etc
     */
    BookingApi.prototype.bookingFindWaybillsCustomerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingFindWaybillsCustomer().');
                        }
                        if (requestParameters['findWaybillsRequest'] == null) {
                            throw new runtime.RequiredError('findWaybillsRequest', 'Required parameter "findWaybillsRequest" was null or undefined when calling bookingFindWaybillsCustomer().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/find".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.FindWaybillsRequestToJSON)(requestParameters['findWaybillsRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.FindWaybillsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * FindWaybills searches waybills by a given column and value, like request_id, bol_number, etc
     */
    BookingApi.prototype.bookingFindWaybillsCustomer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingFindWaybillsCustomerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetBookingRequestByRequestIDRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['requestId'] == null) {
                            throw new runtime.RequiredError('requestId', 'Required parameter "requestId" was null or undefined when calling bookingGetBookingRequestByRequestID().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/status/{requestId}".replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters['requestId']))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetBookingRequestStatusItemFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetBookingRequestByRequestID = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetBookingRequestByRequestIDRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetBookingRequestStatusRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingGetBookingRequestStatus().');
                        }
                        if (requestParameters['requestId'] == null) {
                            throw new runtime.RequiredError('requestId', 'Required parameter "requestId" was null or undefined when calling bookingGetBookingRequestStatus().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/status/{requestId}".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))).replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters['requestId']))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetBookingRequestStatusItemFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetBookingRequestStatus = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetBookingRequestStatusRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetCIFByFuzzyQueryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['getCIFFuzzyQueryRequest'] == null) {
                            throw new runtime.RequiredError('getCIFFuzzyQueryRequest', 'Required parameter "getCIFFuzzyQueryRequest" was null or undefined when calling bookingGetCIFByFuzzyQuery().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/cif/fuzzy_query",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.GetCIFFuzzyQueryRequestToJSON)(requestParameters['getCIFFuzzyQueryRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetCIFFuzzyQueryResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetCIFByFuzzyQuery = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetCIFByFuzzyQueryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * GetDBStatusSummary returns a summary of the database status. This is an ops-only route.  This is meant to facilitate monitoring the DB for DBT propagation.
     */
    BookingApi.prototype.bookingGetDBStatusSummaryRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/admin/db_status_summary",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetDBStatusSummaryResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * GetDBStatusSummary returns a summary of the database status. This is an ops-only route.  This is meant to facilitate monitoring the DB for DBT propagation.
     */
    BookingApi.prototype.bookingGetDBStatusSummary = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetDBStatusSummaryRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetLatestTenderRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingGetLatestTender().');
                        }
                        if (requestParameters['requestId'] == null) {
                            throw new runtime.RequiredError('requestId', 'Required parameter "requestId" was null or undefined when calling bookingGetLatestTender().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customerId}/booking/latest_tender/{requestId}".replace("{".concat("customerId", "}"), encodeURIComponent(String(requestParameters['customerId']))).replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters['requestId']))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetLatestTenderResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetLatestTender = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetLatestTenderRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * GetPattern returns the pattern for a given internal pattern id or external pattern label
     */
    BookingApi.prototype.bookingGetPatternRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingGetPattern().');
                        }
                        if (requestParameters['getPatternRequest'] == null) {
                            throw new runtime.RequiredError('getPatternRequest', 'Required parameter "getPatternRequest" was null or undefined when calling bookingGetPattern().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/patterns/get".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.GetPatternRequestToJSON)(requestParameters['getPatternRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetPatternResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * GetPattern returns the pattern for a given internal pattern id or external pattern label
     */
    BookingApi.prototype.bookingGetPattern = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetPatternRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * GetRailbossFile is used by the gateway to load railboss files from S3. This should not be called by anything other than the gateway.
     */
    BookingApi.prototype.bookingGetRailbossFileRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['filename'] != null) {
                            queryParameters['filename'] = requestParameters['filename'];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/railboss/files",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetRailbossFileResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * GetRailbossFile is used by the gateway to load railboss files from S3. This should not be called by anything other than the gateway.
     */
    BookingApi.prototype.bookingGetRailbossFile = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetRailbossFileRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * GetServiceSummary returns a summary of booking activity for service. It is still a work in progress.
     */
    BookingApi.prototype.bookingGetServiceSummaryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters['duration'] != null) {
                            queryParameters['duration'] = requestParameters['duration'];
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/admin/summary",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetServiceSummaryResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * GetServiceSummary returns a summary of booking activity for service. It is still a work in progress.
     */
    BookingApi.prototype.bookingGetServiceSummary = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetServiceSummaryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetWaybillExtraInfoRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['requestId'] == null) {
                            throw new runtime.RequiredError('requestId', 'Required parameter "requestId" was null or undefined when calling bookingGetWaybillExtraInfo().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/extra_info/{requestId}".replace("{".concat("requestId", "}"), encodeURIComponent(String(requestParameters['requestId']))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetWaybillExtraInfoResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingGetWaybillExtraInfo = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetWaybillExtraInfoRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * GetWaybillFiles returns the contents of given file(s), based on request_id and filename  deprecated, use GetWaybillFilesCustomer instead
     */
    BookingApi.prototype.bookingGetWaybillFilesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['getWaybillFilesRequest'] == null) {
                            throw new runtime.RequiredError('getWaybillFilesRequest', 'Required parameter "getWaybillFilesRequest" was null or undefined when calling bookingGetWaybillFiles().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/files/get",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.GetWaybillFilesRequestToJSON)(requestParameters['getWaybillFilesRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetWaybillFilesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * GetWaybillFiles returns the contents of given file(s), based on request_id and filename  deprecated, use GetWaybillFilesCustomer instead
     */
    BookingApi.prototype.bookingGetWaybillFiles = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetWaybillFilesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * GetWaybillFiles returns the contents of given file(s), based on request_id and filename
     */
    BookingApi.prototype.bookingGetWaybillFilesCustomerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingGetWaybillFilesCustomer().');
                        }
                        if (requestParameters['getWaybillFilesRequest'] == null) {
                            throw new runtime.RequiredError('getWaybillFilesRequest', 'Required parameter "getWaybillFilesRequest" was null or undefined when calling bookingGetWaybillFilesCustomer().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/files/get".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.GetWaybillFilesRequestToJSON)(requestParameters['getWaybillFilesRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetWaybillFilesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * GetWaybillFiles returns the contents of given file(s), based on request_id and filename
     */
    BookingApi.prototype.bookingGetWaybillFilesCustomer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetWaybillFilesCustomerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * GetWaybillFiles returns the contents of given file(s), based on request_id and filename  deprecated, use GetWaybillHistoryCustomer instead
     */
    BookingApi.prototype.bookingGetWaybillHistoryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['getWaybillHistoryRequest'] == null) {
                            throw new runtime.RequiredError('getWaybillHistoryRequest', 'Required parameter "getWaybillHistoryRequest" was null or undefined when calling bookingGetWaybillHistory().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/history",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.GetWaybillHistoryRequestToJSON)(requestParameters['getWaybillHistoryRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetWaybillHistoryResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * GetWaybillFiles returns the contents of given file(s), based on request_id and filename  deprecated, use GetWaybillHistoryCustomer instead
     */
    BookingApi.prototype.bookingGetWaybillHistory = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetWaybillHistoryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * GetWaybillFiles returns the contents of given file(s), based on request_id and filename
     */
    BookingApi.prototype.bookingGetWaybillHistoryCustomerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingGetWaybillHistoryCustomer().');
                        }
                        if (requestParameters['getWaybillHistoryRequest'] == null) {
                            throw new runtime.RequiredError('getWaybillHistoryRequest', 'Required parameter "getWaybillHistoryRequest" was null or undefined when calling bookingGetWaybillHistoryCustomer().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/history".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.GetWaybillHistoryRequestToJSON)(requestParameters['getWaybillHistoryRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetWaybillHistoryResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * GetWaybillFiles returns the contents of given file(s), based on request_id and filename
     */
    BookingApi.prototype.bookingGetWaybillHistoryCustomer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetWaybillHistoryCustomerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * BASF SPECIFIC
     */
    BookingApi.prototype.bookingGetWaybillMappingsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['getWaybillMappingsRequest'] == null) {
                            throw new runtime.RequiredError('getWaybillMappingsRequest', 'Required parameter "getWaybillMappingsRequest" was null or undefined when calling bookingGetWaybillMappings().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/mappings",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.GetWaybillMappingsRequestToJSON)(requestParameters['getWaybillMappingsRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.GetWaybillMappingsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * BASF SPECIFIC
     */
    BookingApi.prototype.bookingGetWaybillMappings = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingGetWaybillMappingsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This is a \"ping\\pong\" route that can be used to test if the service is up and running.
     */
    BookingApi.prototype.bookingHelloWorldRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['hello'] == null) {
                            throw new runtime.RequiredError('hello', 'Required parameter "hello" was null or undefined when calling bookingHelloWorld().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/helloworld",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.HelloToJSON)(requestParameters['hello']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.HelloFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * This is a \"ping\\pong\" route that can be used to test if the service is up and running.
     */
    BookingApi.prototype.bookingHelloWorld = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingHelloWorldRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingListPatternsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingListPatterns().');
                        }
                        if (requestParameters['listPatternsRequest'] == null) {
                            throw new runtime.RequiredError('listPatternsRequest', 'Required parameter "listPatternsRequest" was null or undefined when calling bookingListPatterns().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/patterns/all".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.ListPatternsRequestToJSON)(requestParameters['listPatternsRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ListPatternsResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingListPatterns = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingListPatternsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingListTenderStatusesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingListTenderStatuses().');
                        }
                        if (requestParameters['listTenderStatusesRequest'] == null) {
                            throw new runtime.RequiredError('listTenderStatusesRequest', 'Required parameter "listTenderStatusesRequest" was null or undefined when calling bookingListTenderStatuses().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/tender_statuses".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.ListTenderStatusesRequestToJSON)(requestParameters['listTenderStatusesRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ListTenderStatusesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingListTenderStatuses = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingListTenderStatusesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * ListWaybillFiles lists all the files associated with a given waybill, based on request_id  deprecated, use ListWaybillFilesCustomer instead
     */
    BookingApi.prototype.bookingListWaybillFilesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['listWaybillFilesRequest'] == null) {
                            throw new runtime.RequiredError('listWaybillFilesRequest', 'Required parameter "listWaybillFilesRequest" was null or undefined when calling bookingListWaybillFiles().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/files",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.ListWaybillFilesRequestToJSON)(requestParameters['listWaybillFilesRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ListWaybillFilesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * ListWaybillFiles lists all the files associated with a given waybill, based on request_id  deprecated, use ListWaybillFilesCustomer instead
     */
    BookingApi.prototype.bookingListWaybillFiles = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingListWaybillFilesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * ListWaybillFiles lists all the files associated with a given waybill, based on request_id
     */
    BookingApi.prototype.bookingListWaybillFilesCustomerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingListWaybillFilesCustomer().');
                        }
                        if (requestParameters['listWaybillFilesRequest'] == null) {
                            throw new runtime.RequiredError('listWaybillFilesRequest', 'Required parameter "listWaybillFilesRequest" was null or undefined when calling bookingListWaybillFilesCustomer().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/files".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.ListWaybillFilesRequestToJSON)(requestParameters['listWaybillFilesRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ListWaybillFilesResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * ListWaybillFiles lists all the files associated with a given waybill, based on request_id
     */
    BookingApi.prototype.bookingListWaybillFilesCustomer = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingListWaybillFilesCustomerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * PostDataForCollection is used to collect data before we onboard new clients. If you\'re unsure of where to point things, and aren\'t trying to actually book a tender, this is probably what you\'re looking for.
     */
    BookingApi.prototype.bookingPostDataForCollectionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingPostDataForCollection().');
                        }
                        if (requestParameters['postDataCollectorRequest'] == null) {
                            throw new runtime.RequiredError('postDataCollectorRequest', 'Required parameter "postDataCollectorRequest" was null or undefined when calling bookingPostDataForCollection().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/collector".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.PostDataCollectorRequestToJSON)(requestParameters['postDataCollectorRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.PostDataCollectorResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * PostDataForCollection is used to collect data before we onboard new clients. If you\'re unsure of where to point things, and aren\'t trying to actually book a tender, this is probably what you\'re looking for.
     */
    BookingApi.prototype.bookingPostDataForCollection = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingPostDataForCollectionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingQueryWaybillExtraInfoRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['queryWaybillExtraInfoRequest'] == null) {
                            throw new runtime.RequiredError('queryWaybillExtraInfoRequest', 'Required parameter "queryWaybillExtraInfoRequest" was null or undefined when calling bookingQueryWaybillExtraInfo().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/extra_info/query",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.QueryWaybillExtraInfoRequestToJSON)(requestParameters['queryWaybillExtraInfoRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.QueryWaybillExtraInfoResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingQueryWaybillExtraInfo = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingQueryWaybillExtraInfoRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Replay a tender request. This is an ops-only route. Please be careful when using this! I am intentionally leaving many details  about this endpoint out of the documentation until we have a better understanding of process for this request in the website.
     */
    BookingApi.prototype.bookingReplayRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['replayRequest'] == null) {
                            throw new runtime.RequiredError('replayRequest', 'Required parameter "replayRequest" was null or undefined when calling bookingReplay().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/admin/replay",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.ReplayRequestToJSON)(requestParameters['replayRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.ReplayResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Replay a tender request. This is an ops-only route. Please be careful when using this! I am intentionally leaving many details  about this endpoint out of the documentation until we have a better understanding of process for this request in the website.
     */
    BookingApi.prototype.bookingReplay = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingReplayRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * TestFTPConnection is a route that can be used to test if the FTP connection is working. This is a developer-only route that probably  should be deprecated for something for customer-facing.
     */
    BookingApi.prototype.bookingTestFTPConnectionRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['testFTPConnectionRequest'] == null) {
                            throw new runtime.RequiredError('testFTPConnectionRequest', 'Required parameter "testFTPConnectionRequest" was null or undefined when calling bookingTestFTPConnection().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/admin/test_ftp_connection",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.TestFTPConnectionRequestToJSON)(requestParameters['testFTPConnectionRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.TestFTPConnectionResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * TestFTPConnection is a route that can be used to test if the FTP connection is working. This is a developer-only route that probably  should be deprecated for something for customer-facing.
     */
    BookingApi.prototype.bookingTestFTPConnection = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingTestFTPConnectionRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * FeatureFlags should be sent in the \"feature-flags\" header value. This is a developer-only route meant to test feature flags.
     */
    BookingApi.prototype.bookingTestFeatureFlagRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/v1/test_feature_flag",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.TestFeatureFlagResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * FeatureFlags should be sent in the \"feature-flags\" header value. This is a developer-only route meant to test feature flags.
     */
    BookingApi.prototype.bookingTestFeatureFlag = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingTestFeatureFlagRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingUpdateWaybillMappingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['updateWaybillMappingRequest'] == null) {
                            throw new runtime.RequiredError('updateWaybillMappingRequest', 'Required parameter "updateWaybillMappingRequest" was null or undefined when calling bookingUpdateWaybillMapping().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/booking/mappings/update",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.UpdateWaybillMappingRequestToJSON)(requestParameters['updateWaybillMappingRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.UpdateWaybillMappingResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    BookingApi.prototype.bookingUpdateWaybillMapping = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingUpdateWaybillMappingRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * UpsertPattern creates or updates a pattern, based on the provided pattern data.  This assumes that the pattern data is complete, as well as the associations of input data that will be used to create the pattern.  If these two things need to be in separate calls, then we will add that.
     */
    BookingApi.prototype.bookingUpsertPatternRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['customerId'] == null) {
                            throw new runtime.RequiredError('customerId', 'Required parameter "customerId" was null or undefined when calling bookingUpsertPattern().');
                        }
                        if (requestParameters['upsertPatternRequest'] == null) {
                            throw new runtime.RequiredError('upsertPatternRequest', 'Required parameter "upsertPatternRequest" was null or undefined when calling bookingUpsertPattern().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/{customer_id}/booking/patterns".replace("{".concat("customer_id", "}"), encodeURIComponent(String(requestParameters['customerId']))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.UpsertPatternRequestToJSON)(requestParameters['upsertPatternRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.UpsertPatternResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * UpsertPattern creates or updates a pattern, based on the provided pattern data.  This assumes that the pattern data is complete, as well as the associations of input data that will be used to create the pattern.  If these two things need to be in separate calls, then we will add that.
     */
    BookingApi.prototype.bookingUpsertPattern = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingUpsertPatternRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validate that an EDI document is well-formed. This uses TEDI. This needs work and may give terrible results.
     */
    BookingApi.prototype.bookingValidateEDIRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters['eDIValidationRequest'] == null) {
                            throw new runtime.RequiredError('eDIValidationRequest', 'Required parameter "eDIValidationRequest" was null or undefined when calling bookingValidateEDI().');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/v1/tedi/validate",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: (0, index_1.EDIValidationRequestToJSON)(requestParameters['eDIValidationRequest']),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.EDIValidationResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Validate that an EDI document is well-formed. This uses TEDI. This needs work and may give terrible results.
     */
    BookingApi.prototype.bookingValidateEDI = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingValidateEDIRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the version information of the current service. This is returned as a git sha and build time.
     */
    BookingApi.prototype.bookingVersionRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/version",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, index_1.VersionResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns the version information of the current service. This is returned as a git sha and build time.
     */
    BookingApi.prototype.bookingVersion = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.bookingVersionRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return BookingApi;
}(runtime.BaseAPI));
exports.BookingApi = BookingApi;
